module.exports = __webpack_public_path__ + "front/img/c6.84d79f0e.png";